var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { DivTag } from '../../Utils/AtomicTag';
import { defaultGroupItemProps } from './defaults';
var GroupItem = /** @class */ (function (_super) {
    __extends(GroupItem, _super);
    function GroupItem(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelect = function (clickItemProps, e) {
            // TODO
            //@ts-ignore
            var onItemSelect = _this.props.onItemSelect;
            // TODO
            //@ts-ignore
            onItemSelect(clickItemProps, e);
        };
        _this.renderList = function () {
            var children = _this.props.children;
            if (children) {
                return React.Children.map(children, function (child, index) {
                    if (!child) {
                        return null;
                    }
                    var attribute = {
                        key: child.key,
                        onItemSelect: _this.handleSelect,
                        className: child.props.className,
                    };
                    return React.cloneElement(child, attribute);
                });
            }
            return null;
        };
        _this.renderGroupItem = function () { };
        return _this;
    }
    GroupItem.prototype.render = function () {
        var _a = this.props, title = _a.title, className = _a.className, style = _a.style, rest = __rest(_a, ["title", "className", "style"]);
        var list = this.renderList();
        return title ? (React.createElement("div", __assign({ className: className + " legao-dropdown-group", style: style }, rest),
            React.createElement(DivTag, { atomics: [
                    'font-normal',
                    'pt-px-5',
                    'pr-px-30',
                    'pb-px-5',
                    'pl-px-12',
                    'text-xs',
                    'text-gray-600',
                    'cursor-pointer',
                ] }, title),
            React.createElement(DivTag, { atomics: ['relative', 'z-10'], className: "legao-dropdown-list" }, list))) : (React.createElement(DivTag, __assign({ atomics: ['relative', 'z-10'], className: className + " legao-dropdown-list", style: style }, rest), list));
    };
    GroupItem.defaultProps = defaultGroupItemProps;
    return GroupItem;
}(React.PureComponent));
export default GroupItem;
